
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { useDrag } from "../../Bindings/Fable.ReactDnD.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { map, isEmpty, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import Check_Circle from "../../../public/assets/icons/Check_Circle.svg";
import { dragStepFromElementType } from "./Helper.js";
import { Msg, DragStep } from "./Types.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import Hamburger_Menu_1 from "../../../public/assets/icons/Hamburger_Menu_1.svg";
import { Input, NumberInput } from "../../Components/Input.js";
import { Checkbox } from "../../Components/Checkbox.js";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import Map_Location from "../../../public/assets/icons/Map_Location.svg";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import { ToolState__ToI18nString, ToolState_TryParse_Z721C83C5 } from "../../Shared/Tool.js";
import { Select } from "../../Components/Select.js";
import { SectionHeader } from "../../Components/Text.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { FormState__getValidation } from "../../Shared/Shared.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextButton } from "../../Components/Button.js";

export function DragStepComponent(props) {
    let elems_3, elems_1, elems_2;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["ref", useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => props.DragStep,
        type: "STEP_ELEMENT",
    })[1]], ["className", join(" ", ["p-2", "bg-white", "shadow", "rounded-md", "mb-2", "cursor-pointer", "flex", "flex-row", "items-center", "border", "border-border"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "items-center", "bg-primary", "w-7", "h-7", "rounded-md", "bg-opacity-30"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["h-4", "w-4", "text-primary"]),
        children: reactApi.Children.toArray([props.DragStep.Icon]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", {
        className: join(" ", ["flex-grow", "mx-5"]),
        children: patternInput[0](props.DragStep.TranslationKey),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4", "mx-2"])], (elems_2 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function StepElement(props) {
    let elems_27, elems_26, elems, elems_25;
    const t = useTranslation()[0];
    const baseDragStep = dragStepFromElementType(props.StepElement.Type);
    const patternInput_1 = useDrag({
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        item: (_arg) => (new DragStep(baseDragStep.Id, baseDragStep.TranslationKey, baseDragStep.AssignedId, {
            StepElementPosition: props.StepElement.Position,
            StepPosition: props.StepPosition,
        }, baseDragStep.Type, baseDragStep.Icon)),
        type: "STEP_ELEMENT",
    });
    return reactElement("div", createObj(ofArray([["ref", patternInput_1[2]], ["className", join(" ", toList(delay(() => append(singleton("p-2"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("mb-2"), delay(() => append(singleton("hover:cursor-pointer"), delay(() => append(singleton("items-center"), delay(() => append(singleton("px-4"), delay(() => (props.IsSelected ? append(singleton("border"), delay(() => singleton("border-primary"))) : empty()))))))))))))))))], ["onClick", (e) => {
        e.stopPropagation();
        props.Dispatch(new Msg(10, [props.StepPosition, props.StepElement.Position]));
    }], (elems_27 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-5", "items-center"])], (elems_26 = [reactElement("div", createObj(ofArray([["ref", patternInput_1[1]], ["className", join(" ", ["h-5", "w-5", "hover:pointer"])], (elems = [Hamburger_Menu_1()], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "pointer-events-none"])], (elems_25 = toList(delay(() => {
        let elems_2, elems_1, elems_4, elems_3, elems_6, elems_5, elems_8, elems_11, elems_10, elems_13, elems_12, elems_15, elems_14, elems_17, elems_16, elems_20, elems_19, elems_22, elems_21, elems_24, elems_23;
        const matchValue = props.StepElement.Type;
        switch (matchValue.tag) {
            case 2:
            case 3:
                return singleton(createElement(NumberInput, {
                    ComponentState: "disabled",
                    OnChange: (value_9) => {
                    },
                    TestId: "",
                }));
            case 4:
                return singleton(Checkbox({
                    ComponentState: "disabled",
                    IsChecked: true,
                    Label: props.StepElement.Label,
                    OnCheck: (value_10) => {
                    },
                    TestId: "",
                }));
            case 5:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_1 = [Calendar_Add()], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", {
                    children: t("procedure.step_type.date_time"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            case 6:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_3 = [Map_Location()], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", {
                    children: t("procedure.step_type.location"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
            case 7:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_6 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_5 = [Pencil()], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), reactElement("div", {
                    children: t("procedure.step_type.signature"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
            case 1:
                return singleton(reactElement("div", {
                    className: join(" ", ["flex-grow", "whitespace-pre-wrap"]),
                    children: props.StepElement.Label,
                }));
            case 11:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], (elems_8 = toList(delay(() => append((props.StepElement.Label !== "") ? singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-gray-500", "mb-1"]),
                    children: props.StepElement.Label,
                })) : empty(), delay(() => {
                    let elems_7;
                    return isEmpty(props.StepElement.Options) ? singleton(reactElement("div", {
                        className: join(" ", ["text-gray-400", "italic", "text-sm"]),
                        children: t("procedure.step_type.no_images"),
                    })) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-2"])], (elems_7 = toList(delay(() => map((imageUrl) => reactElement("img", {
                        className: join(" ", ["rounded", "border", "w-16", "h-14", "object-cover"]),
                        src: imageUrl,
                    }), props.StepElement.Options))), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
            case 10:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], (elems_11 = [reactElement("div", {
                    children: props.StepElement.Label,
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1", "mt-1"])], (elems_10 = toList(delay(() => map((opt) => {
                    let elems_9;
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "text-sm", "text-gray-400"])], (elems_9 = [reactElement("div", {
                        className: join(" ", ["w-3", "h-3", "rounded-full", "border", "border-gray-300"]),
                    }), reactElement("span", {
                        children: opt,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
                }, props.StepElement.Options))), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
            case 12:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_13 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_12 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), reactElement("div", {
                    children: t("procedure.step_type.inspection_result"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
            case 13:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_15 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_14 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_14))])]))), reactElement("div", {
                    children: t("procedure.step_type.document_upload"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))));
            case 14:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_17 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_16 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))), reactElement("div", {
                    children: t("procedure.step_type.custom_field"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_17))])]))));
            case 15:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow"])], (elems_20 = [reactElement("div", {
                    children: props.StepElement.Label,
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1", "mt-1"])], (elems_19 = toList(delay(() => map((opt_1) => {
                    let elems_18;
                    let label;
                    const matchValue_1 = ToolState_TryParse_Z721C83C5(opt_1);
                    label = ((matchValue_1 == null) ? opt_1 : t(ToolState__ToI18nString(matchValue_1)));
                    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "text-sm", "text-gray-400"])], (elems_18 = [reactElement("div", {
                        className: join(" ", ["w-3", "h-3", "rounded-full", "border", "border-gray-300"]),
                    }), reactElement("span", {
                        children: label,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_18))])])));
                }, props.StepElement.Options))), ["children", reactApi.Children.toArray(Array.from(elems_19))])])))], ["children", reactApi.Children.toArray(Array.from(elems_20))])]))));
            case 16:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_22 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_21 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_21))])]))), reactElement("div", {
                    children: t("procedure.step_type.storage_transfer"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_22))])]))));
            case 17:
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex-grow", "flex", "items-center", "gap-3"])], (elems_24 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_23 = [Check_Circle()], ["children", reactApi.Children.toArray(Array.from(elems_23))])]))), reactElement("div", {
                    children: t("procedure.step_type.reminder_completion"),
                }), reactElement("div", {
                    children: props.StepElement.Label,
                })], ["children", reactApi.Children.toArray(Array.from(elems_24))])]))));
            case 8:
            case 9:
                return singleton(createElement(Select, {
                    ComponentState: "disabled",
                    IsClearable: false,
                    Label: props.StepElement.Label,
                    NoOptionsMessage: "",
                    OnChange: (value_113) => {
                    },
                    Options: map((opt_2) => ({
                        label: opt_2,
                        value: opt_2,
                    }), props.StepElement.Options),
                    PlaceholderKey: "",
                    TestId: "",
                }));
            default:
                return singleton(createElement(Input, {
                    ComponentState: "disabled",
                    OnChange: (value_8) => {
                    },
                    TestId: "",
                    Value: props.StepElement.Label,
                }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_25))])])))], ["children", reactApi.Children.toArray(Array.from(elems_26))])])))], ["children", reactApi.Children.toArray(Array.from(elems_27))])])));
}

export function ProcedureTemplateTitle(props) {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("flex-row"), delay(() => append(singleton("p-2"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("shadow"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("items-center"), delay(() => (props.IsMainChecklistComponentSelected ? append(singleton("border"), delay(() => singleton("border-primary"))) : empty()))))))))))))))))))], ["onClick", (e) => {
        e.preventDefault();
        props.Dispatch(new Msg(0, []));
    }], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "ml-4"])], (elems = [createElement(SectionHeader, {
        Text: props.ProcedureTemplateForm.Name,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function SidebarComponentStep(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems = [createElement(Input, {
        ComponentState: props.ComponentState,
        Label: t("general.name"),
        OnChange: (value_1) => {
            props.Dispatch(new Msg(8, [props.Position, value_1]));
        },
        TestId: "",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, `${props.Position}-name`)),
        Value: props.ProcedureTemplateStep.Name,
    }), createElement(TextArea, {
        ComponentState: props.ComponentState,
        Label: t("general.description"),
        OnChange: (value_2) => {
            props.Dispatch(new Msg(9, [props.Position, value_2]));
        },
        TestId: "",
        Value: props.ProcedureTemplateStep.Description,
    }), createElement(TextButton, {
        ComponentState: props.ComponentState,
        Label: t("general.delete"),
        OnClick: () => {
            props.Dispatch(new Msg(6, [props.Position]));
        },
        TestId: "remove-step-button-test-id",
        Variant: "redButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

